import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { EmailService } from "src/app/services/email.service";

@Component({
    selector: 'app-component-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyEmailComponent implements OnInit, AfterContentChecked {
    isMobile = window.innerWidth < 1000 ? true : false;
    enableCaptcha: boolean = true;
    formCaptcha: FormGroup;
    siteKey: string;

    constructor(
        private router: Router,
        private emailService: EmailService,
        private titleService: Title,
        private formBuilder: FormBuilder,
        private cdref: ChangeDetectorRef) {
        this.titleService.setTitle("Xác nhận email từ khách hàng");
    }
    ngOnInit() {
        this.formCaptcha = this.formBuilder.group({
            recaptcha: null,
        });
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    goToDefaultPage() {
        this.router.navigate(["/"]);
    }

    verifyEmail() {
        var sValue = "";
        var isCaptchaValid = false;
        this.emailService.verifyEmail(sValue, isCaptchaValid).subscribe(
            res => {

            },
            error => {

            }
        )
    }

    handleSuccess() {
        console.log(this.siteKey);
    }
}